import React from 'react';
import classNames from 'clsx';
import { MediaTypes } from '@wix/fast-gallery-library';
import { renderCustomOrDefaultComp } from '../utils';
import { DefaultImageRenderer } from './DefaultImageRenderer';
const MediaRenderer = props => {
  const getInnerMediaItem = itemContent => {
    let mediaContent;
    switch (itemContent.type) {
      case MediaTypes.VIDEO:
        mediaContent = renderVideoItem(itemContent, itemContent.media);
        break;
      case MediaTypes.IMAGE:
      default:
        {
          var _props$customRenderer;
          mediaContent = renderCustomOrDefaultComp((_props$customRenderer = props.customRenderers) == null ? void 0 : _props$customRenderer.imageRenderer, DefaultImageRenderer, props);
        }
    }
    return mediaContent;
  };
  const renderVideoItem = (itemContent, video) => {
    return /*#__PURE__*/React.createElement("div", null, "videos player is not available yet.. coming soon!", ' ', itemContent.type + video);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, getInnerMediaItem(props.data), /*#__PURE__*/React.createElement("div", {
    className: classNames('overlay')
  }));
};
export default MediaRenderer;
//# sourceMappingURL=MediaRenderer.js.map